<template>
  <div id="merchant-app-page" class="main-page">
    <p class="merchant-app-page-title">Merchant Application </p>
    <div class="container">
      <div class="nav nav-pills nav-justified mb-0 flex-row" id="pills-tab" role="tablist">
        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6">
          <a class="nav-link" :class="{activeClass: selectedTab==0}" @click="selectedTab=0">
            <i class="fas fa-fw fa-rocket"></i> Business
          </a>
          <div class="tab-complete" v-if="count_unfinishedField(contactForms,generalForms,businessAddress) === 0">
            <span class="fa-stack">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="fas fa-check fa-stack-1x fa-inverse"></i>
            </span>
          </div>
          <span class="tab-count" v-else>{{count_unfinishedField(contactForms,generalForms,businessAddress)}}</span>
        </div>

        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6">
          <a
            class="nav-link flex-md-column"
            :class="{activeClass: selectedTab==1}"
            @click="selectedTab=1"
          >
            <i class="fas fa-fw fa-user-circle"></i> Ownership
          </a>
          <div class="tab-complete" v-if="count_unfinishedField(ownerForms) === 0">
            <span class="fa-stack">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="fas fa-check fa-stack-1x fa-inverse"></i>
            </span>
          </div>
          <span class="tab-count" v-else>{{count_unfinishedField(ownerForms)}}</span>
        </div>

        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6">
          <a
            class="nav-link flex-md-column"
            :class="{activeClass: selectedTab==2}"
            @click="selectedTab=2"
          >
            <i class="fas fa-fw fa-handshake"></i> Transactions
          </a>
          <div class="tab-complete" 
          v-if="count_unfinishedField(
            transVolumeForms,
            {'type':filled(transaction_type)},
            {'point':pointCheck(payment_point)},
            {'salespoint':pointCheck(sales_point)},
            bankForms
            ) === 0">
            <span class="fa-stack">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="fas fa-check fa-stack-1x fa-inverse"></i>
            </span>
          </div>
          <span class="tab-count" v-else>{{count_unfinishedField(transVolumeForms,
            {'type':filled(transaction_type)},
            {'point':pointCheck(payment_point)},
            {'salespoint':pointCheck(sales_point)},
            bankForms)}}</span>
        </div>

        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6">
          <a
            class="nav-link flex-md-colum"
            :class="{activeClass: selectedTab==3}"
            @click="selectedTab=3"
          >
            <i class="fas fa-fw fa-cash-register"></i> Equipment
          </a>
         <div class="tab-complete" v-if="count_unfinishedField({'equipment':hasValue(equipmentOnline,equipment)}) === 0 && (equipment!=999||equipmentOnline!=null)">
            <span class="fa-stack">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="fas fa-check fa-stack-1x fa-inverse"></i>
            </span>
          </div>
          <span class="tab-count" v-else>{{count_unfinishedField(hasValue(equipmentOnline,equipment))|| 1}}</span>
        </div>

       

        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6">
          <a
            class="nav-link last-pill"
            :class="{activeClass: selectedTab==4}"
            @click="selectedTab=4"
          >
            <i class="fas fa-fw fa-file-alt"></i> Documentation
          </a>
          <div class="tab-complete" v-if="count_unfinishedField(documentField) === 0">
            <span class="fa-stack">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="fas fa-check fa-stack-1x fa-inverse"></i>
            </span>
          </div>
          <span class="tab-count" v-else>{{count_unfinishedField(documentField)}}</span>
        </div>
         <div 
          class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6"
          :class="{'disabled-option': userappdata.status != 'Approved'}"
        >
          <a
            class="nav-link flex-md-column"
            :class="{activeClass: selectedTab==5}"
            @click="selectedTab=5"
          >
            <i class="fas fa-fw fa-file-signature"></i> Signing
            <div class="tab-complete" v-if="userappdata.is_signed==true">
              <span class="fa-stack">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-check fa-stack-1x fa-inverse"></i>
              </span>
            </div>
            <span class="tab-count" v-else>1</span>
          </a>
        </div>
      </div>
      

      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade"
          :class="{active: selectedTab==0, show: selectedTab==0}"
          id="pills-business"
          role="tabpanel"
          aria-labelledby="pills-business-tab"
        >
          <div class="merchant-app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="merchant-app-section-title">Primary Contact Information</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ countNull(contactForms) }}/
                  {{ Object.keys(contactForms).length }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Name of Primary Contact"
                  v-model="contactForms.contact"
                  nameclass="merchant-app-field"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <phoneInputBase
                  label="Primary Contact's Number"
                  v-model="contactForms.contact_number"
                  nameclass="merchant-app-field last-field-left"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Title of Primary Contact"
                  v-model="contactForms.title"
                  nameclass="merchant-app-field last-field-left"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <emailInputBase
                  v-model="contactForms.email"
                  label="Email"
                  nameclass="merchant-app-field last-field-right"
                />
              </div>
            </div>
          </div>

          <div class="merchant-app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="merchant-app-section-title">General Business Information</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ countNull(generalForms) }}/
                  {{ Object.keys(generalForms).length }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12">
                <textInputBase
                  label="Company Name"
                  v-model="generalForms.company_name"
                  nameclass="merchant-app-field"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Merchant's Legal Business Name"
                  v-model="generalForms.legal_business_name"
                  nameclass="merchant-app-field"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Customer Service Phone"
                  v-model="generalForms.customer_service_phone"
                  nameclass="merchant-app-field"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="DBA Name"
                  v-model="generalForms.dba_name"
                  nameclass="merchant-app-field"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Website URL"
                  v-model="generalForms.website_url"
                  nameclass="merchant-app-field"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12">
                <textInputBase
                  label="Type of Goods or Services you offer"
                  v-model="generalForms.type_offer"
                  nameclass="merchant-app-field"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <operateInputBase
                  label="Where do you operate your business?"
                  nameclass="merchant-app-field"
                  v-model="generalForms.business_operation"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Tax ID / EIN"
                  v-model="generalForms.tax_id"
                  nameclass="merchant-app-field"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <zoneInputBase
                  label="How is your Business Zoned"
                  v-model="generalForms.business_zone"
                  nameclass="merchant-app-field last-field-left"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <numberInputBase
                  label="Number of Locations"
                  v-model="generalForms.number_of_locations"
                  nameclass="merchant-app-field"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <typeBusinessInputBase
                  label="Select Business Type"
                  v-model="generalForms.business_type"
                  nameclass="merchant-app-field last-field-left"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <dateInputBase
                  label="Start Date of Business"
                  v-model="generalForms.startDate"
                  nameclass="merchant-app-field last-field-right"
                />
              </div>
            </div>
          </div>

          <div class="merchant-app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="merchant-app-section-title">Business Address</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ countNull(businessAddress) }} /
                  {{ Object.keys(businessAddress).length }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Street Address"
                  v-model="businessAddress.business_street_address"
                  nameclass="merchant-app-field"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <stateInputBase
                  label="State"
                  v-model="businessAddress.business_state"
                  nameclass="merchant-app-field"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <numberInputBase
                  label="Zip / Postal Code"
                  v-model="businessAddress.business_zip_portal"
                  nameclass="merchant-app-field"
                />
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="City"
                  v-model="businessAddress.business_city"
                  nameclass="merchant-app-field"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <numberInputBase
                      placeholder="Years"
                      v-model="businessAddress.lenght_location_year"
                      label="Length at Location"
                      nameclass="merchant-app-field dual-input-1"
                    />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <numberInputBase
                      placeholder="Months"
                      v-model="businessAddress.lenght_location_month"
                      label
                      nameclass="merchant-app-field dual-input-2"
                    />
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="merchant-app-field">
                  <label for="component-dropdown">Mail statements to the address above?</label>
                  <b-form-select
                    v-model="addressForms.choices"
                    :options="options"
                    class="custom-select custom-select-lg"
                    :style="{backgroundColor:'rgba(79, 208, 110,0.2)'}"
                  ></b-form-select>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  placeholder="Business Street"
                  label="Mailing Address"
                  nameclass="merchant-app-field"
                  v-if="!addressForms.choices"
                  v-model="mailingForms.mail_address"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  placeholder="City"
                  label="City"
                  nameclass="merchant-app-field"
                  v-if="!addressForms.choices"
                  v-model="mailingForms.city"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <stateInputBase
                  label="State"
                  v-model="mailingForms.state"
                  nameclass="merchant-app-field last-field-left"
                  v-if="!addressForms.choices"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <numberInputBase
                  placeholder="Zip"
                  label="Zip / Postal Code"
                  nameclass="merchant-app-field last-field-right"
                  v-if="!addressForms.choices"
                  v-model="mailingForms.business_zip_portal"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          :class="{active: selectedTab==1, show: selectedTab==1}"
          id="pills-ownership"
          role="tabpanel"
          aria-labelledby="pills-ownership-tab"
        >
          <div class="merchant-app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="merchant-app-section-title">Ownership Information #1</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ countNull(ownerForms) }}/
                  {{ Object.keys(ownerForms).length }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Owner Name"
                  nameclass="merchant-app-field"
                  v-model="ownerForms.owner_name"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Street Address"
                  nameclass="merchant-app-field"
                  v-model="ownerForms.street_address"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <stateInputBase
                  label="State"
                  nameclass="merchant-app-field"
                  v-model="ownerForms.state"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <emailInputBase
                  label="Email"
                  nameclass="merchant-app-field"
                  v-model="ownerForms.email"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <numberInputBase
                  label="SSN"
                  nameclass="merchant-app-field"
                  v-model="ownerForms.ssn"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="merchant-app-field">
                  <label>Rent or Own?</label>
                  <b-form-select
                    v-model="ownerForms.business_status"
                    :options="status"
                    size="lg"
                    :style="{
                      backgroundColor: ownerForms.business_status
                        ? 'rgba(79, 208, 110,0.2)'
                        : 'aliceblue',
                    }"
                  >
                    <template v-slot:first>
                      <b-form-select-option value="null" disabled>-- Please select an option --</b-form-select-option>
                    </template>
                  </b-form-select>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <phoneInputBase
                  label="Phone"
                  nameclass="merchant-app-field"
                  v-model="ownerForms.phone_number"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <stateInputBase
                  label="Drivers License or ID State"
                  nameclass="merchant-app-field last-field-left"
                  v-model="ownerForms.license_state"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  placeholder="CEO, Partner, etc."
                  label="Title"
                  nameclass="merchant-app-field"
                  v-model="ownerForms.title"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  placeholder="City"
                  label="City"
                  nameclass="merchant-app-field"
                  v-model="ownerForms.city"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  placeholder="Zip"
                  label="Zip / Postal Code"
                  nameclass="merchant-app-field"
                  v-model="ownerForms.postal_code"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <dateInputBase
                  placeholder="MM/DD/YY"
                  label="Date of Birth"
                  nameclass="merchant-app-field"
                  v-model="ownerForms.date_of_birth"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="merchant-app-field">
                  <label>Equity Ownership</label>
                  <b-form-select
                    v-model="ownerForms.ownership"
                    :options="equity"
                    size="lg"
                    :style="{
                      backgroundColor: ownerForms.ownership
                        ? 'rgba(79, 208, 110,0.2)'
                        : 'aliceblue',
                    }"
                  >
                    <template v-slot:first>
                      <b-form-select-option value="null" disabled>-- Please select an option --</b-form-select-option>
                    </template>
                  </b-form-select>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <numberInputBase
                      placeholder="Years"
                      label="How long at location"
                      nameclass="merchant-app-field dual-input-1"
                      v-model="ownerForms.long_at_location_year"
                    />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <numberInputBase
                      placeholder="Months"
                      label
                      nameclass="merchant-app-field dual-input-2"
                      v-model="ownerForms.long_at_location_month"
                    />
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <numberInputBase
                      placeholder="Years"
                      label="Length of ownership"
                      nameclass="merchant-app-field dual-input-1"
                      v-model="ownerForms.length_of_ownership_year"
                    />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <numberInputBase
                      placeholder="Months"
                      label
                      nameclass="merchant-app-field dual-input-2"
                      v-model="ownerForms.length_of_ownership_month"
                    />
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Drivers License or ID#"
                  nameclass="merchant-app-field last-field-left"
                  v-model="ownerForms.driver_license_id"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <dateInputBase
                  placeholder="MM/DD/YY"
                  label="Drivers License or ID expiry Date"
                  nameclass="merchant-app-field last-field-right"
                  v-model="ownerForms.license_expiry"
                />
              </div>
            </div>
          </div>
          <ownerForm :ownerForms="ownerForms2" :ownerNumber="2" :style="{display: ownerForms2.showed?'block':'none'}" @removeForm="removeOwnerForms('ownerForms2')" />
          <ownerForm :ownerForms="ownerForms3" :ownerNumber="3" :style="{display: ownerForms3.showed?'block':'none'}" @removeForm="removeOwnerForms('ownerForms3')" />
          <b-button v-if="ownerForms2.showed==false||ownerForms3.showed==false" width="40%" style="margin-top:20px;background-color:green;" @click="addMoreOwnerForms()">Add another owner</b-button>
        </div>
        <div
          class="tab-pane fade"
          :class="{active: selectedTab==2, show: selectedTab==2}"
          id="pills-transactions"
          role="tabpanel"
          aria-labelledby="pills-transactions-tab"
        >
          <div class="merchant-app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="merchant-app-section-title">Current Sales Volume</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ countNull(transVolumeForms) }}/
                  {{ Object.keys(transVolumeForms).length }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <moneyInputBase
                  placeholder="Please enter a numeric value"
                  label="What's your estimated average sales per month?"
                  nameclass="merchant-app-field"
                  v-model="transVolumeForms.sales_average"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <moneyInputBase
                  placeholder="Please enter a numeric value"
                  label="What's your average transaction Amount?"
                  nameclass="merchant-app-field last-field-left"
                  v-model="transVolumeForms.transaction_average"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <moneyInputBase
                  placeholder="Please enter a numeric value"
                  label="What's your maximum transaction Amount?"
                  v-model="transVolumeForms.max_transaction"
                  nameclass="merchant-app-field last-field-right"
                />
              </div>
            </div>
          </div>

          <div class="merchant-app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="merchant-app-section-title">Transaction Types</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ filled(transaction_type) || 0 }}/
                  1
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="merchant-app-field">
                  <label>
                    Please classify your business type by checking the
                    appropriate boxes.
                  </label>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <transInputBase v-model="transaction_type" />
              </div>
            </div>
          </div>
          <div class="merchant-app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p
                  class="merchant-app-section-title"
                >Tell us how you are going to accept your payments</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ pointCheck(payment_point) ||0}}/
                  1
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <percentInputBase
                  label="On Premise Sales"
                  nameclass="merchant-app-field"
                  v-model.number="transPaymentForms.on_premise_sales"
                  @input="payMentPoints"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <percentInputBase
                  label="Mail Order"
                  nameclass="merchant-app-field"
                  @input="payMentPoints"
                  v-model.number="transPaymentForms.mail_order"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <percentInputBase
                  label="Off Premise Sales"
                  @input="payMentPoints"
                  nameclass="merchant-app-field last-field-left"
                  v-model.number="transPaymentForms.off_premise_sales"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <percentInputBase
                  label="Internet Order"
                  @input="payMentPoints"
                  nameclass="merchant-app-field"
                  v-model.number="transPaymentForms.internet_order"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <percentInputBase
                  label="Telephone Order"
                  @input="payMentPoints"
                  nameclass="merchant-app-field last-field-left"
                  v-model.number="transPaymentForms.telephone_order"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <percentInputBase
                  disabled
                  @change="payMentPoints"
                  label="Total (Must Equal 100%)"
                  :nameclass="{
                    'merchant-app-field last-field-right': !payment_point,
                    error: payment_point != 100 && payment_point,
                  }"
                  v-model.number="payment_point"
                />
                <p
                  class="validation-message"
                  v-if="payment_point != 100 && payment_point"
                >Must equal 100</p>
              </div>
            </div>
          </div>

          <div class="merchant-app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="merchant-app-section-title">Sales Distribution</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ pointCheck(sales_point) ||0}}/
                  1
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <percentInputBase
                  label="Sales Swiped"
                  nameclass="merchant-app-field"
                  v-model.number="salesForms.sales_swiped"
                  @input="result"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <percentInputBase
                  label="Sales Keyed"
                  nameclass="merchant-app-field last-field-left"
                  v-model.number="salesForms.sales_keyed"
                  @input="result"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <percentInputBase
                  disabled
                  label="Total (Must Equal 100%)"
                  v-model="sales_point"
                  @change="result"
                  :nameclass="{
                    'merchant-app-field last-field-right': !sales_point,
                    error: sales_point != 100 && sales_point,
                  }"
                />
                <p
                  class="validation-message"
                  v-if="sales_point != 100 && sales_point"
                >Must equal 100</p>
              </div>
            </div>
          </div>
          <div class="merchant-app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="merchant-app-section-title">Bank Account Information (For Deposits)</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ countNull(bankForms) }}/
                  {{ Object.keys(bankForms).length }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Bank/Financial Institution Name"
                  nameclass="merchant-app-field"
                  v-model="bankForms.bank_name"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <numberInputBase
                  label="Routing #"
                  nameclass="merchant-app-field last-field-left"
                  v-model="bankForms.routing"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <numberInputBase
                  label="Account #"
                  nameclass="merchant-app-field last-field-left"
                  v-model="bankForms.account"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="merchant-app-field last-field-right">
                  <label>Bank Account Type</label>
                  <b-form-select
                    v-model="bankForms.bank_account_type"
                    :options="savingType"
                    size="lg"
                    :style="{
                      backgroundColor: bankForms.bank_account_type
                        ? 'rgba(79, 208, 110,0.2)'
                        : 'aliceblue',
                    }"
                  >
                    <template v-slot:first>
                      <b-form-select-option value="null" disabled>-- Please select an option --</b-form-select-option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </div>
          </div>
          <div class="merchant-app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="merchant-app-section-title">Processing History</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right"></div>
            </div>
            <choicesInputBase
              label="Do you currently accept Visa/Mastercard/Discover?"
              v-model="cardholderForms.accept_card"
              nameclass="merchant-app-label"
              ids="1"
            />

            <choicesInputBase
              ids="2"
              label="Have you ever had a merchant account terminated (TMF/MATCH)?"
              v-model="cardholderForms.tmf"
              nameclass="merchant-app-label"
            />
            <div class="merchant-app-section-label" v-if="cardholderForms.tmf">
              <b-row>
                <b-col class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12">
                  <label for="choices" class="merchant-app-label">Are you on the TMF match list?</label>
                </b-col>
                <b-col class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                  <b-form-group>
                    <b-form-radio-group
                      id="radio-group-3"
                      v-model="cardholderForms.on_tmf"
                      :options="yesOrno3"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <choicesInputBase
              label="Has any Principle filed for Bankruptcy"
              v-model="cardholderForms.principle_bankruptcy"
              nameclass="merchant-app-label"
            />
            <div class="merchant-app-section-label" v-if="cardholderForms.principle_bankruptcy">
              <b-row>
                <b-col class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12">
                  <label for="choices" class="merchant-app-label">Bankruptcy Explanation</label>
                </b-col>
                <b-col class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                  <b-form-textarea
                    id="textarea"
                    v-model="cardholderForms.bankruptcy_description"
                    rows="4"
                    max-rows="6"
                    style="overflow:hidden"
                  ></b-form-textarea>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="merchant-app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p
                  class="merchant-app-section-title"
                >Cardholder Data Storage Compliance & Service Provider</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right"></div>
            </div>
            <b-row>
              <b-col class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12">
                <label for="choices" class="merchant-app-label">
                  1. Have you ever experienced an Account Data Compromise
                  "ADC"?
                </label>
              </b-col>
              <b-col class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                <b-form-group>
                  <b-form-radio-group
                    v-model="processingForms.account_Data_Compromise"
                    :options="yesOrno"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>

            <div class="row" v-if="processingForms.account_Data_Compromise == 'yes'">
              <div class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="merchant-app-label">
                  <label>If yes, provide date of compromise</label>
                </div>
              </div>
              <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                <dateInputBase
                  label="_"
                  style="color:white;"
                  v-model="processingForms.account_Data_Compromise_date"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="merchant-app-label">
                  <label>
                    a) Have you validated PCI DSS (Payment Card Industry Data
                    Security Standard) compliance?
                  </label>
                </div>
              </div>
              <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                <b-form-group>
                  <b-form-radio-group v-model="processingForms.pci_dss" :options="yesOrno"></b-form-radio-group>
                </b-form-group>
              </div>
            </div>
            <div class="row" v-if="processingForms.pci_dss == 'yes'">
              <div class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="merchant-app-label">
                  <label>
                    Date of compliance, Report on Compliance "ROC" or Self
                    Assessment Questionnaire "SAQ"?
                  </label>
                </div>
              </div>
              <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                <dateInputBase label="_" style="color:white;" v-model="processingForms.roc_saq" />
              </div>
            </div>
            <div class="row" style="padding-top:10px;" v-if="processingForms.pci_dss == 'yes'">
              <div class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="merchant-app-label">
                  <label>
                    What is the name of your Qualified Security Assessor
                    "QSA"
                  </label>
                </div>
              </div>
              <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase label="__" v-model="processingForms.qsa" />
              </div>
            </div>

            <div class="row" style="padding-top:10px;" v-if="processingForms.pci_dss == 'yes'">
              <div class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="merchant-app-label">
                  <label>Date of last scan</label>
                </div>
              </div>
              <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                <dateInputBase
                  label="_"
                  style="color:white;"
                  v-model="processingForms.last_scan_date"
                />
              </div>
            </div>
            <div class="row" style="padding-top:10px;" v-if="processingForms.pci_dss == 'yes'">
              <div class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="merchant-app-label">
                  <label>Approved Scanning Vendor's name:</label>
                </div>
              </div>
              <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase label="__" v-model="processingForms.vendor_name" />
              </div>
            </div>
            <div class="row" style="padding-top:10px;" v-if="processingForms.pci_dss == 'yes'">
              <div class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="merchant-app-label">
                  <label>
                    Do your transactions process through any other Service
                    Provider (ie web hosting companies, gateways, corporate
                    office)?
                  </label>
                </div>
              </div>
              <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                <b-form-group>
                  <b-form-radio-group v-model="processingForms.service_provider" :options="yesOrno"></b-form-radio-group>
                </b-form-group>
              </div>
            </div>
            <div
              class="row"
              style="padding-top:10px;"
              v-if="processingForms.service_provider == 'yes'"
            >
              <div class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="merchant-app-label">
                  <label>If yes, name the other Service Provider?</label>
                </div>
              </div>
              <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase label="__" v-model="processingForms.service_provider_name" />
              </div>
            </div>
          </div>
        </div>

        <div
          class="tab-pane fade"
          :class="{active: selectedTab==3, show: selectedTab==3}"
          id="pills-equipment"
          role="tabpanel"
          aria-labelledby="pills-equipment-tab"
        >
          <div class="merchant-app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="merchant-app-section-title">Equipment Information</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{count_unfinishedField({'equipment':hasValue(equipmentOnline,equipment)}) === 0 && (equipment!=999||equipmentOnline!=null) ? 1:0}}/
                  1
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <crediCardInputBase class="merchant-app-field last-field-left" v-model="equipment" />
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" v-if="equipment == 999">
                <cartInputBase
                  class="merchant-app-field last-field-right"
                  v-model="equipmentOnline"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          class="tab-pane fade"
          :class="{active: selectedTab==5, show: selectedTab==5}"
          id="pills-docusign"
          role="tabpanel"
          aria-labelledby="pills-docusign-tab"
        >
              <div v-if="userappdata.status=='Incomplete' || userappdata.status=='Reject'" class="merchant-app-section">
                <div class="container" style="text-align:center;">
                  <h4>Please complete the previous sections in order to do document signing.</h4>
                </div>
                  
                
              </div>
              <div v-if="userappdata.is_signed==false && userappdata.signed_url" class="container-fluid" id="signeasy">
                <div v-if="iframeLoading==true" class="signeasy-loading">
                  <p class="signeasy-loading-text">  
                    <i class="fas fa-spinner fa-pulse"></i> Loading...
                  </p>
                </div>
              </div>
              <div v-else-if="userappdata.is_signed==true" class="container-fluid" id="signeasy">
              </div>
              <div v-else class="row" id="signeasy">
              </div>
        </div>

        <div
          class="tab-pane fade"
          :class="{active: selectedTab==4, show: selectedTab==4}"
          id="pills-documentation"
          role="tabpanel"
          aria-labelledby="pills-documentation-tab"
        >
          <documentationBase ref="document" />
        </div>
      </div>
    </div>
    <div class="container merchant-app-save text-center">
      <button
        class="purple-btn"
        @click="save"
        :disabled="
          (payment_point != 100 && payment_point != null) ||
            (sales_point != 100 && sales_point != null) || loading == true
        "
      >Save</button>
    </div>
  </div>
</template>

<script>
$(document).ready(function() {
  $(".nav-link").click(function() {
    $(".nav-link").removeClass("active");
  });
});
import helper from '@/helper/helper';
import {
  textInputBase,
  transInputBase,
  emailInputBase,
  phoneInputBase,
  numberInputBase,
  moneyInputBase,
  percentInputBase,
  stateInputBase,
  zoneInputBase,
  operateInputBase,
  typeBusinessInputBase,
  dateInputBase,
  choicesInputBase,
  crediCardInputBase,
  cartInputBase,
  documentationBase
} from "../components/forms/baseForms";
import Vue from "vue";
import { mapState } from "vuex";
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Axios from "axios";
import ownerForm from "../components/display/OwnerForm"







Vue.use(VueFormWizard);

export default {
  mixins: [helper],
  components: {
    textInputBase,
    emailInputBase,
    phoneInputBase,
    numberInputBase,
    moneyInputBase,
    percentInputBase,
    stateInputBase,
    zoneInputBase,
    operateInputBase,
    typeBusinessInputBase,
    dateInputBase,
    choicesInputBase,
    transInputBase,
    crediCardInputBase,
    cartInputBase,
    documentationBase,
    ownerForm
  },
  methods: {
    removeOwnerForms(stateName) {
      // const selectedOwnerState = 'ownerForms' + index;
      // this.ownerFormsShowed[index] = false;
      // this.$set(this.ownerFormsShowed, this.ownerFormsShowed)
      this[stateName] = {
        showed: false,
        title: null,
        owner_name: null,
        date_of_birth: null,
        street_address: null,
        city: null,
        postal_code: null,
        ssn: null,
        phone_number: null,
        business_status: null,
        long_at_location_year: null,
        long_at_location_month: null,
        email: null,
        driver_license_id: null,
        license_expiry: null,
        ownership: null,
        state: null,
        license_state: null
      }
    },
    addMoreOwnerForms() {
      const ownerFormsShowedList = [true, this.ownerForms2.showed, this.ownerForms3.showed];
      const index = ownerFormsShowedList.indexOf(false) + 1
      if (index<0) return;
      const selectedOwnerState = 'ownerForms' + index;
      this[selectedOwnerState].showed = true;

      // this.ownerFormsShowed[index] = true;
      // this.$set(this.ownerFormsShowed, this.ownerFormsShowed);
    },
    removeSigneasy() {
      var iframe = document.getElementById("signeasy-iframe");
      if (iframe) {
        $('#signeasy-iframe').remove();
        this.loaded = true;
      }
    },
    Signeasy() {
        // console.log("iframe done loading");
        // $(".signeasy-loading").hide();
        var iframe = document.getElementsByTagName("IFRAME");
        if(this.userappdata.status=='Reject' || this.userappdata.status=='Incomplete') {
          this.iframeLoading = false;
          if (iframe.length>0) {
            iframe[0].remove()
            this.loaded = true;
          }
          return
        } else {
          this.iframeLoading = true;
        }
          this.iframeLoading = true;
          var changedUrl = 0
        if(this.userappdata.is_signed && this.loaded){
          this.loaded = false;
          var url = `https://api.gunspring.com/applications/sign/?pending_file_id=${this.userappdata.signeasy_id}`
          $("#signeasy").append("<iframe id='signeasy-iframe' src=" + url + "></iframe>");
          $('#signeasy-iframe').on('load', (data) => {
          // console.log('iframe is completely loaded');
          this.iframeLoading = false;
        })
        }else if (this.userappdata.is_signed==false && this.userappdata.signed_url && this.loaded){
          this.loaded = false;
        $("#signeasy").append("<iframe id='signeasy-iframe' src=" + this.userappdata.signed_url + "></iframe>");
          $('#signeasy-iframe').on('load', (data) => {
         changedUrl += 1
        //  console.log(changedUrl,'counter')
         if (changedUrl >= 3){
           this.userappdata.is_signed = true
         }

          this.iframeLoading = false;
        })
        

        }else{
          this.iframeLoading = false;
          return
        }
        // $("#ifram").on( 'load', function() {
        //   console.log("wtf");
        // });
      
    },
    set_activeTab(){
      var tab_status = [
        this.count_unfinishedField(this.contactForms,this.generalForms,this.businessAddress),
        this.count_unfinishedField(this.ownerForms),
        this.count_unfinishedField(this.transVolumeForms,
            {'type':this.filled(this.transaction_type)},
            {'point':this.pointCheck(this.payment_point)},
            {'salespoint':this.pointCheck(this.sales_point)},
            this.bankForms),
           this.count_unfinishedField({'equipment':this.hasValue(this.equipmentOnline,this.equipment)}),
            this.count_unfinishedField(this.documentField)
      ]
      for (var index in tab_status){
        if (tab_status[index] != 0){
          this.selectedTab=index
          break
        }else{
          this.selectedTab=5
        }
       
      }
    },
    get_totalfield(){
      var contact = this.countNull(this.contactForms)
      var generalForms = this.countNull(this.generalForms)
      var businessAddress = this.countNull(this.businessAddress)
      var ownerForms = this.countNull(this.ownerForms)
      var transVolumeForms = this.countNull(this.transVolumeForms)
      var transaction_type = this.filled(this.transaction_type)||0
      var transPaymentForms = this.pointCheck(this.payment_point)||0
      var salesForms = this.pointCheck(this.sales_point)||0
      var bankForms = this.countNull(this.bankForms)
      var equipmentOnline = this.hasValue(this.equipmentOnline,this.equipment)||0
      var docField = this.docVal()
      var total = contact+generalForms+businessAddress+
                  ownerForms+
                  transVolumeForms+
                  transaction_type+
                  transPaymentForms+
                  salesForms+
                  bankForms+
                  equipmentOnline+docField
      return total

    },
    docVal: function(){
      var val =this.$refs.document;
     var vals = val.get_filledField();
     return vals
    },
    pointCheck(obj){
      if(obj == 100){
        return 1
      }else{
        return null
      }
    },
    hasValue(obj, obj2) {
      if (obj || obj2 != null) {
        return 1;
      } else {
        return null;
      }
    },
    filled: function(obj) {
      if (obj.length > 0) {
        return 1;
      } else {
        return null;
      }
    },
    result_check: function() {
      if (this.salesForms.sales_swiped || this.salesForms.sales_keyed) {
        this.sales_point =
          this.salesForms.sales_swiped + this.salesForms.sales_keyed;
      }
    },
    payMentPoints_check: function() {
      if (
        this.transPaymentForms.on_premise_sales ||
        this.transPaymentForms.internet_order ||
        this.transPaymentForms.mail_order ||
        this.transPaymentForms.telephone_order ||
        this.transPaymentForms.off_premise_sales
      ) {
        this.payment_point =
        parseInt(this.transPaymentForms.on_premise_sales) +
        parseInt(this.transPaymentForms.internet_order) +
        parseInt(this.transPaymentForms.mail_order) +
        parseInt(this.transPaymentForms.telephone_order) +
        parseInt(this.transPaymentForms.off_premise_sales);
      }
    },
    payMentPoints: function() {
      var resul =null
      var obj =this.transPaymentForms
      for (let i in obj){
        if (obj[i]){
          resul += obj[i]
        }
      }
      this.payment_point = resul
      return resul
    },
    result: function() {
        var resul =null
      var obj =this.salesForms
      for (let i in obj){
        if (obj[i] && obj[i] != ''){
          resul += obj[i]
        }
      }
      this.sales_point = resul
      return resul
    },
    countNull(obj) {
      let result = 0;
      for (let i in obj) {
        if (obj[i] === null || obj[i] === '') {
        }else{
          result++
        }
      }
      return result;
    },
    fillEquity() {
      for (var i = 1; i <= 100; i++) {
        this.equity.push({ value: i, text: i + "%" });
      }
    },
    get_general() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.accessToken
        }
      };
      Axios.get(`apps/merchantapps/${this.appCode}/`, config)
        .then(response => {
          if (response.status == 200) {
            this.generalForms.dba_name = response.data.dba_name;
            this.requirements.business_id = response.data.id;
            this.requirements.business_owner = response.data.business_owner;
            this.generalForms.website_url = response.data.website_url;
            this.addressForms.choices = response.data.same_mailing_address;
            this.generalForms.startDate = response.data.business_start_date;
            this.generalForms.business_type = response.data.business_type;
            this.generalForms.business_zip_portal =
              response.data.business_zip_portal;
            this.businessAddress.business_city = response.data.business_city;
            this.generalForms.business_operation =
              response.data.business_operation;
            this.businessAddress.business_state = response.data.business_state;
            this.businessAddress.business_street_address =
              response.data.business_street_address;
            this.generalForms.business_type = response.data.business_type;
            this.businessAddress.business_zip_portal =
              response.data.business_zip_portal;
            this.generalForms.business_zone = response.data.business_zone;
            this.generalForms.company_name = response.data.company_name;
            this.generalForms.customer_service_phone =
              response.data.customer_service_phone;
            this.generalForms.legal_business_name =
              response.data.legal_business_name;
            this.businessAddress.lenght_location_month =
              response.data.lenght_location_month;
            this.businessAddress.lenght_location_year =
              response.data.lenght_location_year;
            this.generalForms.type_offer = response.data.type_offer;
            this.generalForms.tax_id = response.data.tax_id;
            this.generalForms.number_of_locations =
              response.data.number_of_locations;
            this.requirements.business_contact = response.data.business_contact;
            this.addressForms.choices = response.data.same_mailing_address;
            this.get_contact();
            this.get_owner();
            this.get_mailingAdress();
            this.get_bank();
            this.get_transaction();
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    get_contact() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.accessToken
        }
      };
      Axios.get(
        `apps/merchantapps/${this.requirements.business_contact}/contact/`,
        config
      )
        .then(response => {
          if (response.status == 200) {
            this.contactForms.contact = response.data.contact;
            this.contactForms.title = response.data.title;
            this.contactForms.contact_number = response.data.contact_number;
            this.contactForms.email = response.data.email;
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    get_mailingAdress() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.accessToken
        }
      };
      Axios.get(
        `apps/merchantapps/${this.requirements.business_id}/mailing/`,
        config
      ).then(response => {
        this.mailingForms.mail_address = response.data.mail_address;
        this.mailingForms.city = response.data.city;
        this.mailingForms.business_zip_portal =
          response.data.business_zip_portal;
        this.mailingForms.state = response.data.state;
      });
    },
    get_owner() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.accessToken
        }
      };
      Axios.get(
        `apps/merchantapps/${this.requirements.business_owner}/owner/`,
        config
      )
        .then(response => {
          if (response.status == 200) {
            this.ownerForms.title = response.data.title;
            this.ownerForms.owner_name = response.data.owner_name;
            this.ownerForms.date_of_birth = response.data.date_of_birth;
            this.ownerForms.street_address = response.data.street_address;
            this.ownerForms.city = response.data.city;
            this.ownerForms.postal_code = response.data.postal_code;
            this.ownerForms.ssn = response.data.ssn;
            this.ownerForms.phone_number = response.data.phone_number;
            this.ownerForms.business_status = response.data.business_status;
            this.ownerForms.long_at_location_year =
              response.data.long_at_location_year;
            this.ownerForms.long_at_location_month =
              response.data.long_at_location_month;
            this.ownerForms.email = response.data.email;
            this.ownerForms.driver_license_id = response.data.driver_license_id;
            this.ownerForms.license_expiry = response.data.license_expiry;
            this.ownerForms.ownership = response.data.ownership;
            this.ownerForms.state = response.data.state;
            this.ownerForms.license_state = response.data.license_state;
            this.ownerForms.length_of_ownership_year = response.data.length_of_ownership_year;
            this.ownerForms.length_of_ownership_month = response.data.length_of_ownership_month;
            if (response.data.owners!=null||response.data.owners!='null') {
              if (response.data.owners.owner_2) this.ownerForms2 = response.data.owners.owner_2;
              if (response.data.owners.owner_3) this.ownerForms3 = response.data.owners.owner_3;
            }
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    get_bank() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.accessToken
        }
      };
      Axios.get(
        `apps/merchantapps/${this.requirements.business_id}/bank/`,
        config
      )
        .then(response => {
          this.requirements.bank_id = response.data.id;
          this.bankForms.bank_name = response.data.bank_name;
          this.bankForms.routing = response.data.routing;
          this.bankForms.account = response.data.account;
          this.bankForms.bank_account_type = response.data.bank_account_type;
        })
        .catch(error => {
          // console.log(error);
        });
    },
    get_transaction() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.accessToken
        }
      };
      Axios.get(
        `apps/merchantapps/${this.requirements.business_id}/transaction/`,
        config
      )
        .then(response => {
          if (response.status == 200) {
            this.requirements.trans_id = response.data.id;
            this.transVolumeForms.sales_average = response.data.sales_average;
            this.transVolumeForms.transaction_average =
              response.data.transaction_average;
            this.transVolumeForms.max_transaction =
              response.data.max_transaction;
            this.transPaymentForms.on_premise_sales =
              response.data.on_premise_sales;
            this.transPaymentForms.internet_order =
              response.data.internet_order;
            this.transPaymentForms.mail_order = response.data.mail_order;
            this.transPaymentForms.telephone_order =
              response.data.telephone_order;
            this.transPaymentForms.off_premise_sales =
              response.data.off_premise_sales;
            this.salesForms.sales_swiped = response.data.sales_swiped;
            this.salesForms.sales_keyed = response.data.sales_keyed;
            this.cardholderForms.accept_card = response.data.accept_card;
            this.cardholderForms.tmf = response.data.tmf;
            this.cardholderForms.on_tmf = response.data.on_tmf;
            this.cardholderForms.principle_bankruptcy =
              response.data.principle_bankruptcy;
            this.cardholderForms.bankruptcy_description =
              response.data.bankruptcy_description;
            this.processingForms.account_Data_Compromise =
              response.data.account_Data_Compromise;
            this.processingForms.account_Data_Compromise_date =
              response.data.account_Data_Compromise_date;
            this.processingForms.pci_dss = response.data.pci_dss;
            this.processingForms.roc_saq = response.data.roc_saq;
            this.processingForms.qsa = response.data.qsa;
            this.processingForms.last_scan_date = response.data.last_scan_date;
            this.processingForms.vendor_name = response.data.vendor_name;
            this.processingForms.service_provider =
              response.data.service_provider;
            this.processingForms.service_provider_name =
              response.data.service_provider_name;
            if (
              response.data.equipment != null &&
              response.data.equipment > 2
            ) {
              this.equipment = 999;
              this.equipmentOnline = response.data.equipment;
            } else {
              this.equipment = response.data.equipment;
            }
            this.transaction_type = response.data.transaction_type;
            this.result_check();
            this.payMentPoints();
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    put_contact() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.accessToken
        }
      };
      let data = {
        contact: this.contactForms.contact,
        title: this.contactForms.title,
        contact_number: this.contactForms.contact_number,
        email: this.contactForms.email
      };
      Axios.put(
        `apps/merchantapps/${this.requirements.business_contact}/contact/`,
        data,
        config
      )
        .then(response => {
          if (response.status == 200) {
            // console.log("contact saved");
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    put_mailingAdress() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.accessToken
        }
      };
      let data = {
        business: this.requirements.business_id,
        mail_address: this.mailingForms.mail_address,
        city: this.mailingForms.city,
        business_zip_portal: this.mailingForms.business_zip_portal||null,
        state: this.mailingForms.state
      };
      Axios.put(
        `apps/merchantapps/${this.requirements.business_id}/mailing/`,
        data,
        config
      ).then(response => {
        // console.log(response);
      });
    },
    put_owner() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.accessToken
        }
      };
      let data = {
        title: this.ownerForms.title,
        owner_name: this.ownerForms.owner_name,
        date_of_birth: this.ownerForms.date_of_birth||null,
        street_address: this.ownerForms.street_address,
        city: this.ownerForms.city,
        postal_code: this.ownerForms.postal_code||null,
        ssn: this.ownerForms.ssn||null,
        phone_number: this.ownerForms.phone_number,
        business_status: this.ownerForms.business_status,
        long_at_location_year: this.ownerForms.long_at_location_year||null,
        long_at_location_month: this.ownerForms.long_at_location_month||null,
        email: this.ownerForms.email,
        driver_license_id: this.ownerForms.driver_license_id,
        license_expiry: this.ownerForms.license_expiry||null,
        ownership: this.ownerForms.ownership,
        state: this.ownerForms.state,
        license_state: this.ownerForms.license_state,
        length_of_ownership_year:this.ownerForms.length_of_ownership_year,
        length_of_ownership_month:this.ownerForms.length_of_ownership_month,
        owners:{
          owner_2: this.ownerForms2.showed==true?this.ownerForms2:null,
          owner_3: this.ownerForms3.showed==true?this.ownerForms3:null
        }
      };
      Axios.put(
        `apps/merchantapps/${this.requirements.business_owner}/owner/`,
        data,
        config
      )
        .then(response => {
          if (response.status == 200) {
            console.log("owner saved");
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    put_bank() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.accessToken
        }
      };
      let data = {
        company: this.requirements.business_id,
        bank_name: this.bankForms.bank_name,
        routing: this.bankForms.routing||null,
        account: this.bankForms.account||null,
        bank_account_type: this.bankForms.bank_account_type
      };
      Axios.put(
        `apps/merchantapps/${this.requirements.bank_id}/bank/`,
        data,
        config
      )
        .then(response => {
          //   if (response.status == 200) {
          //     console.log("bank saved");
          //   }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    put_transaction() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.accessToken
        }
      };
      var equips = null;
      if (this.equipment != null && this.equipment > 2) {
        equips = this.equipmentOnline;
      } else {
        equips = this.equipment;
      }
      let data = {
        sales_average: this.transVolumeForms.sales_average||null,
        transaction_average: this.transVolumeForms.transaction_average||null,
        max_transaction: this.transVolumeForms.max_transaction||null,
        on_premise_sales: this.transPaymentForms.on_premise_sales|| null,
        internet_order: this.transPaymentForms.internet_order|| null,
        mail_order: this.transPaymentForms.mail_order|| null,
        telephone_order: this.transPaymentForms.telephone_order || null,
        off_premise_sales: this.transPaymentForms.off_premise_sales|| null,
        sales_swiped: this.salesForms.sales_swiped|| null,
        sales_keyed: this.salesForms.sales_keyed|| null,
        accept_card: this.cardholderForms.accept_card,
        tmf: this.cardholderForms.accept_card,
        on_tmf: this.cardholderForms.on_tmf,
        principle_bankruptcy: this.cardholderForms.principle_bankruptcy,
        bankruptcy_description: this.cardholderForms.bankruptcy_description,
        account_Data_Compromise: this.processingForms.account_Data_Compromise,
        account_Data_Compromise_date: this.processingForms
          .account_Data_Compromise_date,
        pci_dss: this.processingForms.pci_dss,
        roc_saq: this.processingForms.roc_saq,
        qsa: this.processingForms.qsa,
        last_scan_date: this.processingForms.last_scan_date||null,
        vendor_name: this.processingForms.vendor_name,
        service_provider: this.processingForms.service_provider,
        service_provider_name: this.processingForms.service_provider_name,
        business: this.requirements.business_id,
        equipment: equips,
        transaction_type: this.transaction_type
      };
      Axios.put(
        `apps/merchantapps/${this.requirements.trans_id}/transaction/`,
        data,
        config
      )
        .then(response => {
          // if (response.status == 200) {
          // }
        })
        .catch(error => {
          // console.log(error);
        });
    },

    save_docs: function() {
      var save = this.$refs.document;
      save.put_document();
    },
    save() {
      this.save_button_start();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.accessToken
        }
      };
      let data = {
        app: this.appCode,
        dba_name: this.generalForms.dba_name,
        website_url: this.generalForms.website_url,
        same_mailing_address: this.addressForms.choices,
        business_start_date: this.generalForms.startDate||null,
        business_type: this.generalForms.business_type,
        business_city: this.businessAddress.business_city,
        business_operation: this.generalForms.business_operation,
        business_state: this.businessAddress.business_state,
        business_street_address: this.businessAddress.business_street_address,
        business_zip_portal: this.businessAddress.business_zip_portal||null,
        business_zone: this.generalForms.business_zone,
        company_name: this.generalForms.company_name,
        customer_service_phone: this.generalForms.customer_service_phone,
        legal_business_name: this.generalForms.legal_business_name,
        lenght_location_month: this.businessAddress.lenght_location_month||null,
        lenght_location_year: this.businessAddress.lenght_location_year||null,
        type_offer: this.generalForms.type_offer,
        tax_id: this.generalForms.tax_id||null,
        number_of_locations: this.generalForms.number_of_locations||null
      };
      Axios.put(`apps/merchantapps/${this.appCode}/`, data, config)
        .then(response => {
          if (response.status == 200) {
            this.put_contact();
            this.put_owner();
            if (!this.addressForms.choices) {
              this.put_mailingAdress();
            }
            this.put_bank();
            this.put_transaction();
            this.save_docs();
            var appdata = {
              appcode:this.appCode,
              dba:this.generalForms.dba_name,
              completed_field:this.get_totalfield()
            }
            this.get_general();
            this.$store.dispatch("update_app",appdata).then(res =>{
              if (res.status == 200){
                this.$store.dispatch('loadUserapp',this.appCode).then(resp =>{
                  if (resp.status == 200){
                    setTimeout(() => {this.toast_saved(),this.selectedTab++,window.scrollTo(0,0);}, 3000);
                    setTimeout(() => this.save_button_end(), 3000);
                    this.removeSigneasy();
                  }
                });
              }
            });
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    save_button_start() {
      this.loading = true;
      $(".merchant-app-save .purple-btn").html(
        'Saving <i class="fas fa-circle-notch fa-spin"></i>'
      );
    },
    save_button_end() {
      this.loading = false;
      $(".merchant-app-save .purple-btn").html("Save");
    },
    toast_saved() {
      this.$bvToast.toast(`Form saved!`, {
        toaster: "b-toaster-bottom-full",
        autoHideDelay: 2000,
        bodyClass: "toast-saved",
        noCloseButton: true
      });
    }
  },
  created() {
    this.get_general();
  },
  mounted()  {
    this.fillEquity();
    setTimeout(()=>this.set_activeTab(),2000)
    this.$store.dispatch('loadUserapp',this.appCode)

  },
    
  
  computed: {
  accessToken () {
    return this.$store.state.accessToken
  },
  appCode () {
    return this.$store.state.appCode?this.$store.state.appCode:this.$route.params.key
  },
  documentField () {
    return this.$store.state.documentField
  },
  userappdata(){
    return this.$store.getters.user_app_data
  },
  },
  watch: {
    transPaymentForms(updated, old) {},
    equipment(updated, old) {
      if (updated) {
        this.equipment = updated;
      }
    },
    sales_point(updated, old) {
      if (updated) {
        this.sales_point = updated;
      }
    },
    payment_point(updated, old) {
      if (updated) {
        this.payment_point = updated;
      }
    },
    selectedTab(updated, old) {
      if (updated==5) {
        this.Signeasy();
      }
    }
  },

  data() {
    return {
      loaded:true,
      loading: false,
      yesOrno3: [
        { value: "yes", text: "Yes" },
        { value: "No", text: "No" },
        { value: "I don't know", text: "I don't know" }
      ],
      yesOrno: [
        { value: "yes", text: "Yes" },
        { value: "no", text: "No" }
      ],
      payment_point: null,
      sales_point: null,
      savingType: [
        { value: "Savings", text: "Savings" },
        { value: "General Ledger", text: "General Ledger" },
        { value: "Business Checking", text: "Business Checking" }
      ],
      status: [
        { value: "Rent", text: "Rent" },
        { value: "Own", text: "Own" }
      ],
      equity: [],
      options: [
        { value: true, text: "Yes" },
        { value: false, text: "No" }
      ],
      transaction_type: [],
      equipment: null,
      equipmentOnline: null,
      mailingForms: {
        mail_address: null,
        city: null,
        business_zip_portal: null,
        state: null
      },
      requirements: {
        business_contact: null,
        business_owner: null,
        business_id: null,
        bank_id: null,
        trans_id: null,
        document_id: null
      },
      // ownerFormsShowed: [true, false, false],
      ownerForms: {
        title: null,
        owner_name: null,
        date_of_birth: null,
        street_address: null,
        city: null,
        postal_code: null,
        ssn: null,
        phone_number: null,
        business_status: null,
        long_at_location_year: null,
        long_at_location_month: null,
        email: null,
        driver_license_id: null,
        license_expiry: null,
        ownership: null,
        state: null,
        license_state: null,
        length_of_ownership_year:null,
        length_of_ownership_month:null
      },
      ownerForms2: {
        showed: false,
        title: null,
        owner_name: null,
        date_of_birth: null,
        street_address: null,
        city: null,
        postal_code: null,
        ssn: null,
        phone_number: null,
        business_status: null,
        long_at_location_year: null,
        long_at_location_month: null,
        email: null,
        driver_license_id: null,
        license_expiry: null,
        ownership: null,
        state: null,
        license_state: null,
        length_of_ownership_year:null,
        length_of_ownership_month:null
      },
      ownerForms3: {
        showed: false,
        title: null,
        owner_name: null,
        date_of_birth: null,
        street_address: null,
        city: null,
        postal_code: null,
        ssn: null,
        phone_number: null,
        business_status: null,
        long_at_location_year: null,
        long_at_location_month: null,
        email: null,
        driver_license_id: null,
        license_expiry: null,
        ownership: null,
        state: null,
        license_state: null,
        length_of_ownership_year:null,
        length_of_ownership_month:null
      },
      contactForms: {
        contact: null,
        title: null,
        contact_number: null,
        email: null
      },
      generalForms: {
        startDate: "",
        website_url: "",
        business_operation: null,
        business_type: null,
        business_zone: null,
        company_name: null,
        customer_service_phone: null,
        legal_business_name: null,
        type_offer: null,
        tax_id: null,
        number_of_locations: null,
        dba_name: null
      },
      businessAddress: {
        business_street_address: null,
        business_state: null,
        lenght_location_year: null,
        lenght_location_month: null,
        business_city: null,
        business_zip_portal: null
      },
      addressForms: { choices: null },
      transVolumeForms: {
        sales_average: null,
        transaction_average: null,
        max_transaction: null
      },
      transPaymentForms: {
        on_premise_sales: null,
        internet_order: null,
        mail_order: null,
        telephone_order: null,
        off_premise_sales: null
      },
      salesForms: {
        sales_swiped: null,
        sales_keyed: null
      },
      bankForms: {
        bank_name: null,
        routing: null,
        account: null,
        bank_account_type: null
      },
      processingForms: {
        account_Data_Compromise: "no",
        account_Data_Compromise_date: null,
        pci_dss: "no",
        service_provider: "no",
        service_provider_name: "",
        roc_saq: "",
        qsa: "",
        last_scan_date: "",
        vendor_name: ""
      },
      cardholderForms: {
        accept_card: false,
        tmf: false,
        on_tmf: null,
        principle_bankruptcy: false,
        bankruptcy_description: ""
      },
      // documentationsForms: {
      //   driver_license: null,
      //   Articles_of_Incorporation: null,
      //   Months_of_Bank_Statements: null,
      //   Voided_Check: null,
      //   Marketing_Material_Sample: null,
      //   Months_of_Processing_Statements: null
      // },
      selectedTab: 0,
      iframeLoading: true
    };
  }
};
</script>

<style>
#signeasy {
  position: relative;
  margin: 50px 15px 0 15px;
  width: 100vw;
  /* position: relative; */
  margin-left: -50vw;
  height: 100%;
  /* margin-top: 100px; */
  left: 50%;
}
#signeasy iframe {
  width: 100%;
  height: 1250px;
}
.signeasy-loading {
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 2;
  left: 0;
  top: 0;
}
.signeasy-loading-text {
  text-align: center;
  top: 50%;
  position: relative;
  color: white;
}
.view-document {
  font-size: 18px;
  display: inline-block;
  color: white !important;
  background: #673ab7;
  padding: 5px 15px;
  border-radius: 4px;
}

.delete-document {
  font-size: 18px;
  margin-left: 10px;
  display: inline-block;
  color: white !important;
  background: #f44336;
  padding: 5px 15px;
  border-radius: 4px;
}

.view-document:hover {
  background: #512da8;
  text-decoration: none;
}

.delete-document:hover {
  background: #d32f2f;
  text-decoration: none;
}

.toast-saved {
  background: #1976d2;
  color: white;
  font-size: 32px;
  font-weight: 500;
  text-align: center;
  width: 100%;
}

.merchant-app-page-title {
  font-size: 40px;
  font-weight: 500;
  text-align: center;
}

.activeClass {
  background-color: #673ab7 !important;
  color: white !important;
}

.nav-pills .nav-link.active {
  background-color: #673ab7 !important;
}

.nav-pills .nav-link {
  color: #673ab7;
  border: 1px solid #673ab7;
  text-align: center;
  cursor: pointer;
}

.disabled-option {
  cursor: not-allowed;
}

.nav-pills .nav-link.disabled {
  border-color: #6c757d;
  color: #6c757d;
}

.nav-pills .nav-link i {
  display: block;
  margin: 0 auto;
}

#merchant-app-page {
  margin-bottom: 75px;
}

#merchant-app-page #pills-tab {
  margin-top: 35px;
}

.stepTitle {
  margin-top: 5px;
  font-weight: 500;
}

.b-form-datepicker button {
  background-color: #673ab7;
  border-color: #673ab7;
}

.btn-outline-primary {
  color: #673ab7;
}

.asdad {
  color: #f3e5f5;
}

.show > .btn-primary.dropdown-toggle,
.b-form-datepicker .btn-primary:not(:disabled):not(.disabled):active,
.b-form-datepicker .btn-primary:focus,
.b-form-datepicker button:hover {
  background-color: #512da8 !important;
  border-color: #512da8 !important;
}

.b-calendar-grid-body .btn-outline-primary {
  color: #673ab7;
}

.b-calendar-grid-body .btn-outline-primary:hover {
  background-color: #673ab7;
}

.b-calendar-grid-body .btn-primary:not(:disabled):not(.disabled).active:focus {
  box-shadow: 0 0 0 0.2rem #f3e5f5;
}

.b-calendar-grid-body .btn-primary:not(:disabled):not(.disabled).active {
  background-color: #673ab7;
}

.wizard-icon-circle:focus {
  outline: none;
}

.vue-form-wizard .wizard-title {
  font-weight: 500;
  margin-bottom: 25px;
}

.merchant-app-save {
  margin-top: 50px;
  margin-bottom: 75px;
}

.merchant-app-section-title {
  font-size: 32px;
  font-weight: 500;
}

.fields-completed-count {
  border: 1px solid #673ab7;
  display: inline-block;
  padding: 10px 15px;
  border-radius: 4px;
}

.merchant-app-field:not(.last-field-left):not(.last-field-right):not(.last-field) {
  margin-bottom: 35px;
}

.merchant-app-section {
  margin-top: 35px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 50px;
}

.merchant-app-label,
.merchant-app-field label,
.merchant-app-field select,
.merchant-app-field input {
  width: 100%;
}

.merchant-app-label,
.merchant-app-field label {
  font-weight: 500;
}

.radio-options:not(.last-radio-options-right) {
  margin-bottom: 35px;
}

.merchant-app-field select {
  padding: 10px;
}

.merchant-app-field input {
  padding: 8px 10px;
}

.dual-input-2 {
  margin-top: 8px;
}

@media (max-width: 1199.98px) {
  .nav-pills .col-lg-2 {
    padding-left: 5px;
    padding-right: 5px;
  }
}

@media (max-width: 991.98px) {
  .nav-pills .col-md-4:nth-child(n + 4) {
    margin-top: 20px;
  }

  .view-document,
  .delete-document {
    padding: 5px 13px;
  }
}

@media (max-width: 767.98px) {
  .merchant-app-page-title {
    font-size: 32px;
  }

  .nav-pills .col-sm-6:nth-child(n + 3) {
    margin-top: 20px;
  }

  .merchant-app-section-title {
    font-size: 22px;
  }

  .fields-completed-count {
    font-size: 12px;
  }

  .last-field-left {
    margin-bottom: 35px;
  }

  .dual-input-1 {
    margin-bottom: 0 !important;
  }

  .dual-input-2 {
    margin-top: 0;
  }

  .merchant-app-section {
    padding: 25px;
  }

  .fields-completed-count {
    padding: 10px;
  }

  .vue-form-wizard .wizard-tab-content {
    padding: 0;
  }

  .error select {
    border-color: red;
    background: #fdd;
  }

  .error input {
    border-color: red;
    background: #fdd !important;
  }

  .error:focus {
    outline-color: #f99;
  }
   
}
</style>
